var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _styledSystem = require("@sport1/styled-system");

var _get = _interopRequireDefault(require("lodash/get"));

var _FormationRow = _interopRequireDefault(require("./FormationRow"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationHalf.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationHalf = function (_React$Component) {
  (0, _inherits2.default)(FormationHalf, _React$Component);

  var _super = _createSuper(FormationHalf);

  function FormationHalf() {
    (0, _classCallCheck2.default)(this, FormationHalf);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormationHalf, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formation = _this$props.formation,
          teamKitColor = _this$props.teamKitColor,
          away = _this$props.away,
          imageUrl = _this$props.imageUrl,
          system = _this$props.system,
          onPress = _this$props.onPress,
          fieldWidth = _this$props.fieldWidth,
          createPlayerHref = _this$props.createPlayerHref,
          renderPlayer = _this$props.renderPlayer,
          fontStyle = _this$props.fontStyle,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["formation", "teamKitColor", "away", "imageUrl", "system", "onPress", "fieldWidth", "createPlayerHref", "renderPlayer", "fontStyle", "NavWrapper"]);
      if (!formation || !formation.length) return null;
      return _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        position: "relative",
        flexing: true,
        evenly: true,
        py: 1,
        reverseColumn: away
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.View, {
        bg: "transparent",
        position: "absolute",
        left: !away ? (0, _styledSystem.themeGet)('space.3', 16)(this.props) + "px" : '0px',
        right: away ? (0, _styledSystem.themeGet)('space.3', 16)(this.props) + "px" : '0px',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Row, {
        alignItems: "center",
        reverseRow: away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 21
        }
      }, imageUrl ? _react.default.createElement(_Logos.TeamLogo, {
        size: 20,
        src: imageUrl,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 37
        }
      }) : null, system ? _react.default.createElement(_Basic.Text, {
        size: "small",
        ml: (0, _PropsHelper.getValueConditionally)(!away, 1),
        mr: (0, _PropsHelper.getValueConditionally)(away, 1),
        style: fontStyle,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 29
        }
      }, system) : null)), _react.default.createElement(_Basic.View, {
        bg: "transparent",
        borderX: 1,
        borderY: 1,
        borderColor: "formation.lines",
        width: "40%",
        height: "25%",
        opacity: 0.4,
        position: "absolute",
        top: (0, _PropsHelper.getValueConditionally)(!away, '-1px'),
        bottom: (0, _PropsHelper.getValueConditionally)(away, '-1px'),
        left: "30%",
        zIndex: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64,
          columnNumber: 17
        }
      }), formation.map(function (playerRow, index) {
        return [_react.default.createElement(_FormationRow.default, {
          key: "row_" + (0, _get.default)(playerRow, '[0].lastName') + "_" + (0, _get.default)(playerRow, '[0].jerseyNumber'),
          isGoalKeeper: index === 0,
          away: away,
          row: playerRow,
          onPress: onPress,
          fieldWidth: fieldWidth,
          createPlayerHref: createPlayerHref,
          renderPlayer: renderPlayer,
          fontStyle: fontStyle,
          NavWrapper: NavWrapper,
          teamColor: teamKitColor,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79,
            columnNumber: 21
          }
        })];
      }));
    }
  }]);
  return FormationHalf;
}(_react.default.Component);

FormationHalf.propTypes = {
  formation: _propTypes.default.instanceOf(Array),
  teamKitColor: _propTypes.default.object,
  name: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  system: _propTypes.default.string,
  away: _propTypes.default.bool,
  onPress: _propTypes.default.func,
  fieldWidth: _propTypes.default.number,
  NavWrapper: _propTypes.default.func
};
FormationHalf.defaultProps = {
  away: false
};

var _default = (0, _styledComponents.withTheme)(FormationHalf);

exports.default = _default;